<template>
    <div>
        <div v-masonry gutter="15" transition-duration="0s" item-selector=".item">
            <div v-bind:key="index" v-masonry-tile class="item"
                 v-for="(influencer, index) in filterInfluencers">
                <card shadow class="card-profile p-4 mb-3" no-body style="max-width: 21.8rem">
                    <div class="px-4">
                        <div class="text-center mt-3">
                            <div class="w-100" style="height:120px; background-position: center;position:relative  "
                                 :style="{ 'background-image': 'url(' + influencer.profile_background_image_url_https + ')' }">

                            </div>
                            <a :href="'https://twitter.com/'+influencer.screen_name" target="_blank">
                                <img style="position:absolute; top:70px; left:40%;"
                                     :src="influencer.profile_image_url_https | largeImage"
                                     class="rounded-circle w-25 mt-3">
                            </a>
                        </div>
                        <div class="text-center mt-4">
                            <a :href="'https://twitter.com/'+influencer.screen_name" target="_blank">
                                <h4> {{influencer.name}}
                                    <span class="d-block font-weight-light small">@{{influencer.screen_name}}</span>
                                </h4>
                            </a>
                            <div class="h6 font-weight-300">{{influencer.location}}</div>

                        </div>

                        <div class="d-block">
                            {{influencer.description}}
                        </div>
                        <div class="mt-5 text-center">
                            <badge type="twitter" rounded>{{influencer.statuses_count}}
                                Tweets
                            </badge>
                            <badge type="success" rounded>{{influencer.favourites_count}}
                                Favorites
                            </badge>
                            <badge class="mt-1" type="warning" rounded>{{influencer.friends_count}}
                                Friends
                            </badge>
                            <badge type="warning" rounded>{{influencer.followers_count}}
                                Followers
                            </badge>

                        </div>
                    </div>
                </card>
            </div>

        </div>
        <div class="d-flex justify-content-center" v-if="maxIndex < 100">
            <base-button tag="a"
                         class="mb-3 w-25 mb-sm-0 bg-ptwist text-white"
                         type="button"
                         @click="loadMore">
                Load more
            </base-button>
        </div>
    </div>
</template>
<script>
import imagesLoaded from 'vue-images-loaded'

export default {
  name: 'influencers-masonry',
  directives: {
    imagesLoaded
  },
  computed: {
    filterInfluencers () {
      return this.influencers.filter((influencer, index) => index < this.maxIndex && influencer.screen_name !== 'PlasticTwistBot')
    }
  },
  methods: {
    loadMore () {
      if (this.maxIndex < 100) {
        this.maxIndex += 9
      }
    }
  },
  props: ['influencers'],
  data () {
    return {
      maxIndex: 9
    }
  },
  created () {
    setInterval(() => this.$redrawVueMasonry(), 500)
  },
  filters: {
    largeImage (imageUrl) {
      return imageUrl.replace('_normal', '_400x400')
    }
  }

}
</script>
<style>
</style>
